import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2, DollarSign } from "lucide-react";

// Transparent starting-price guidance without locking exact pricing.
const tiers = [
  {
    name: "Cold Calling Seat",
    from: "$1,495",
    unit: "/seat / month",
    notes: ["Full-time dedicated caller", "180, 250 dials / day", "Daily activity & KPI logs"],
  },
  {
    name: "Appointment Setter",
    from: "$1,795",
    unit: "/seat / month",
    notes: ["Live transfers + calendar booking", "Trained on US REI motivation", "Weekly QA & coaching"],
  },
  {
    name: "Acquisition Manager",
    from: "$2,495",
    unit: "/seat / month",
    notes: ["Runs seller calls + comps", "Contract & follow-through", "Reports into your CEO"],
  },
];

const PricingAnchor = () => (
  <section id="pricing" className="section-padding bg-muted/40 scroll-mt-24">
    <div className="container-narrow">
      <div className="max-w-2xl">
        <div className="gold-divider" />
        <h2 className="mt-4 font-display text-3xl font-bold text-foreground md:text-4xl">
          Transparent starting pricing
        </h2>
        <p className="mt-3 text-muted-foreground">
          Final pricing depends on volume, hours, and stack. Below are honest starting points so you
          can estimate before the call, typically 60, 70% less than a comparable US hire fully
          loaded.
        </p>
      </div>

      <div className="mt-10 grid gap-5 md:grid-cols-3">
        {tiers.map((t) => (
          <div key={t.name} className="rounded-2xl border border-border bg-card p-6">
            <div className="text-xs font-semibold uppercase tracking-wider text-secondary">{t.name}</div>
            <div className="mt-3 flex items-baseline gap-1">
              <span className="text-xs text-muted-foreground">from</span>
              <span className="font-display text-3xl font-extrabold text-foreground">{t.from}</span>
              <span className="text-xs text-muted-foreground">{t.unit}</span>
            </div>
            <ul className="mt-5 space-y-2">
              {t.notes.map((n) => (
                <li key={n} className="flex items-start gap-2 text-sm text-muted-foreground">
                  <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-secondary" />
                  <span>{n}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-8 flex flex-wrap items-center justify-between gap-4 rounded-xl border border-border bg-background p-5">
        <div className="flex items-start gap-3">
          <DollarSign className="mt-0.5 h-5 w-5 shrink-0 text-secondary" />
          <p className="text-sm text-muted-foreground">
            Month-to-month. No setup fee on standard engagements. Volume discounts on 3+ seats.
            Exact quote on the strategy call.
          </p>
        </div>
        <Link to="/book">
          <Button className="bg-secondary text-secondary-foreground hover:bg-secondary/90">
            Get my exact quote <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </div>
    </div>
  </section>
);

export default PricingAnchor;
